// Period Lock
export const PERIOD_LOCK_CUSTOMER_ID_KEY = 'customer';
export const PERIOD_LOCK_DATE_FROM_KEY = 'dateFrom';
export const PERIOD_LOCK_DATE_TO_KEY = 'dateTo';
export const PERIOD_LOCK_DEFINITION_ID = 'periodLockDefinitionId';
export const PERIOD_LOCK_LOCK_DATE_KEY = 'lockDate';
export const PERIOD_LOCK_STATUS_KEY = 'status';
export const PERIOD_LOCK_MODIFIED_AT_KEY = 'modifiedAt';
export const PERIOD_LOCK_MODIFIED_BY_KEY = 'modifiedBy';
export const PERIOD_LOCK_ACTIONS_KEY = 'actions';
export const PERIOD_LOCK_TABLE_KEY = 'v1/period-lock';
export const PERIOD_LOCK_SETTINGS_SAVE = 'period_lock_v2';
export const PERIOD_LOCK_STATUS_UNLOCKED_KEY = 'unlocked';
export const PERIOD_LOCK_STATUS_LOCKED_KEY = 'locked';
export const PERIOD_LOCK_STATUS_CURRENT_KEY = 'current';
export const PERIOD_LOCK_STATUS_WAITING_KEY = 'waiting';

export const PeriodLockTranslationKeys = {
  customer: 'table_list.columns.customerId',
  dateFrom: 'table_list.columns.dateFrom',
  dateTo: 'table_list.columns.dateTo',
  lockDate: 'table_list.columns.lockDate',
  status: 'table_list.columns.status',
  modifiedAt: 'table_list.columns.modifiedAt',
  modifiedBy: 'table_list.columns.modifiedBy',
};

// Period Lock Definition
export const PERIOD_LOCK_DEFINITION_CUSTOMER_ID_KEY = 'customer';
export const PERIOD_LOCK_DEFINITION_ENABLED = 'enabled';
export const PERIOD_LOCK_DEFINITION_LOCK_TO = 'lockTo';
export const PERIOD_LOCK_DEFINITION_LOCK_AFTER_TYPE = 'lockAfterType';
export const PERIOD_LOCK_DEFINITION_CREATED_AT = 'createdAt';
export const PERIOD_LOCK_DEFINITION_CREATED_BY = 'createdBy';
export const PERIOD_LOCK_DEFINITION_MODIFIED_AT = 'modifiedAt';
export const PERIOD_LOCK_DEFINITION_MODIFIED_BY = 'modifiedBy';
export const PERIOD_LOCK_DEFINITION_LOCK_AFTER_PERIODS = 'lockAfterPeriods';
export const PERIOD_LOCK_DEFINITION_LOCK_AFTER = 'lockAfter';
export const PERIOD_LOCK_DEFINITION_TABLE_KEY = 'v1/period-lock-definition';
export const PERIOD_LOCK_DEFINITION_SETTINGS_SAVE = 'period_lock_definition_v2';
export const PERIOD_LOCK_DEFINITION_URL = '/period-lock/definition';
export const PERIOD_LOCK_DEFINITION_CUSTOMERS = 'customersForPeriodLockDefinition';

export const PeriodLockDefinitionTranslationKeys = {
  customer: 'table_list.columns.customerId',
  enabled: 'table_list.columns.periodLocks.enabled',
  lockAfter: 'table_list.columns.periodLocks.lockAfter',
  lockTo: 'table_list.columns.periodLocks.lockTo',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedAt: 'table_list.columns.modifiedAt',
  modifiedBy: 'table_list.columns.modifiedBy',
};
